import React from 'react'
import MemberCard from '../../Common/MemberCard/MemberCard'
import styles from './Team.module.scss'

const Team = ({ title, teamList, eyebrow, subtitle }: any) => {
  return (
    <div className={styles['team-wrapper']}>
      <div className={styles['heading-text']}>
        {eyebrow && <span className={styles['eyebrow']}>{eyebrow}</span>}
        <p className={styles['header']}>{title}</p>
        {subtitle && <p className={styles['header-text']}>{subtitle}</p>}
      </div>

      <div className={styles['cards']}>
        {teamList.map((item: any, index: any) => (
          <MemberCard
            key={`${title}-member-${index}`}
            linkedin={item.linkedin}
            path={item.path}
            name={item.name}
            role={item.role}
            maxWidth={item.maxWidth}
          />
        ))}
      </div>
    </div>
  )
}

export default Team
